module.exports = __webpack_public_path__ + "img/game_main_pc_15_off.78830391.png";